
export enum MFAErrorcodeEnum {
  InvalidMFAToken = 4034,
  MFATokenAlreadyVerified = 4035,
  MFATokenExpired = 4036,
  MFATokenLockedOut = 4037,
  MFADeviceIdIsNotSame = 4038,
  MFAIncorrectCode = 4039
}
